import React from 'react';
import { useHistory } from 'react-router';
import { useSpring, animated } from '@react-spring/web'
import useWindowDimensions from './../../helpers/WindowDemnsions';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { CONVERSTAION } from '../../navigation/Constants';

const DoubleMatch = (props: any) => {
    const { height, width } = useWindowDimensions();
    const fromLeft = useSpring({ to: { transform: "translateX(0px)", }, from: { transform: `translateX(-${width / 6}px)` } })
    const fromRight = useSpring({ to: { transform: "translateX(0px)" }, from: { transform: `translateX(${width / 6}px)` } })
    const { memberCode: myMemberCode } = useSelector((state: RootState) => state.member);
    const { data } = props?.location?.state;
    const { prevLocation } = props.location.state;
    let history = useHistory();

    const navigate = () => {
        if (prevLocation.includes("popup=chat")) { //was added because when you would go back and it was a chat screen the app would crash because it was lacking the needed props
            history.replace(CONVERSTAION);
            return;
        }
        history.replace(prevLocation);
    };

    const navigateToChatProps = {
        pathname: `/chat/${data.doubleMatchMember.memberCode}`,
        state: {
            memberName: data.doubleMatchMember.memberName,
            userName: data.doubleMatchMember.userName,
            memberImage: data.doubleMatchMember.profileImage,
            isNavigateFromProfilePage: false,
            chatMemberCode: data.doubleMatchMember.memberCode,
        }
    };

    const navigateToChat = () => {
        history.replace(navigateToChatProps);
    };

    return (
        <React.Fragment>
            <div className="meet_sec">
                <div className="meet_form_block w-form">
                    <div className="login_logo meet">
                        {/* <img src="/assets/images/shoshke_logo_notxt.svg" loading="lazy" alt="" /> */}
                    </div>
                    <h1 className="meet_title" style={{ marginBottom: "0px" }}>איזה יופי!</h1>
                    <h1 className="meet_title" style={{ marginTop: "0px" }}> יש לך התאמה עם {data.doubleMatchMember.userName}</h1>
                    <div className="meet_picts_group">
                        <animated.div style={fromLeft} className="meet_pict">
                            <img
                                src={data.myMember.profileImage ?? "/assets/images/noPhoto.png"}
                                loading="lazy"
                                alt=""
                                className="item_pict"
                            />
                        </animated.div>
                        <animated.div style={fromRight} className="meet_pict">
                            <img
                                src={data.doubleMatchMember.profileImage ?? "/assets/images/noPhoto.png"}
                                loading="lazy"
                                alt=""
                                className="item_pict"
                            />
                        </animated.div>
                    </div>
                    <div className="meet_form">

                        <div>
                            <div className="form_field_content meet">
                                <div className="field_block meet">
                                    {/* <label className="meet_label">
                                    גם {data.doubleMatchMember.userName} רוצה להכיר אותך
                                </label> */}
                                    <div className="meet_label">
                                        איזה כיף שגם {data.doubleMatchMember.userName} רוצה להכיר אותך. <br /> עכשיו תוכלו לשלוח הודעות ולהתחיל להכיר! רוצה להתחיל להתכתב?
                                    </div>

                                </div>
                            </div>
                            <div className="form_buttons_group meet">
                                <a href="#" onClick={navigateToChat} className="button_full meet-_send w-button">
                                    שליחת הודעה
                                    {/* <img src="assets/images/ic_send.svg" loading="lazy" alt="" className="ic_button" /> */}
                                </a>
                            </div>
                        </div>
                    </div>
                    <a href="#" onClick={navigate} className='skip_link meet_exit' >
                        <div>לא הפעם</div>
                    </a>

                </div>
            </div>


        </React.Fragment>
    )

}

export default DoubleMatch;


